export function getOnlyKey() {
  return Math.random();
}
